export default __webpack_public_path__ + "static/imgannonce2-80f3236ed62c265b2136c6806a9ac8b4.jpg";